import { useMemo } from 'react';
import { Row, TextButton, Typography } from 'seagull';
import { ArrowHead } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import { useResponsive } from "../../../../contexts";
import { getStepName } from "../../../ClientOnboarding.utils";
import { getVendorGradientStyle } from "../../ClientOnboardingV2.utils";
import desktopStyles from "../../OnboardingPage/Steps/StepsContainer/StepsContainerDesktop.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
export const GetHeaderTID = parentTestId => getTestIds({
  parentTestId
});
export const Header = _ref => {
  let {
    currentStep,
    relationship,
    onBack,
    testId
  } = _ref;
  const {
    isMobile
  } = useResponsive();
  const {
    HeaderTestIds
  } = useMemo(() => GetHeaderTID(testId), [testId]);
  const gradientStyle = getVendorGradientStyle(relationship.vendor.branding);
  const stepTitle = useMemo(() => getStepName(currentStep, relationship), [currentStep, relationship]);
  if (isMobile) {
    return /*#__PURE__*/_jsx(Typography, {
      variant: "h3",
      weight: "normal",
      "data-testid": HeaderTestIds.StepTitle(),
      children: stepTitle
    });
  }
  return /*#__PURE__*/_jsx(Row, {
    className: desktopStyles.header,
    style: gradientStyle,
    "data-testid": HeaderTestIds.Root(),
    children: /*#__PURE__*/_jsx(Row, {
      className: desktopStyles.headerContent,
      "data-testid": HeaderTestIds.HeaderContent(),
      children: /*#__PURE__*/_jsx(TextButton, {
        prefixIcon: /*#__PURE__*/_jsx(ArrowHead, {
          direction: "left"
        }),
        onClick: onBack,
        skin: "secondary",
        underline: "never",
        variant: "h4",
        weight: "normal",
        "data-testid": HeaderTestIds.BackButton(),
        children: /*#__PURE__*/_jsx("span", {
          "data-testid": HeaderTestIds.StepTitle(),
          children: stepTitle
        })
      })
    })
  });
};